
<headerCustom></headerCustom>

<sidebarWrapper></sidebarWrapper>

<div class="main-content">
    <div class="adduserContainer">
        <div class="pageContentWrapper">
          <div class="pageHeading">
            <div class="row">
              <div class="col-12">
                <div class="headerName">
                  <h3>Compute Score</h3>
                  <app-breadcrumb></app-breadcrumb>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="scoreCompStyle" id="adduserPopContainer"
                *ngIf="userList && userList.length >0">
                <div>
                  <div class="headerName">
                    <div class="row">
                        <label class="col-md-12">Select User</label>
                      <div class="col-md-4">
                              <select class="form-control" [(ngModel)]="selectedCombinedId" placeholder="Select User" (change)="getNextPosition()">
                                <option value="Select User">Select User</option>
                                <ng-container *ngFor="let user of userList; let i = index;">
                                  <option value="{{user.userId}}_{{user.currentPosition}}_{{user.nextPosition}}_{{user.towerId}}">{{user.userName}}</option>
                                </ng-container>
                              </select>

                              <div class="mar15" *ngIf="nextPositionId">
                                Current Role: <strong>{{ currentPositionName }}</strong> <br />
                                Next Role: <strong>{{ getPositionName(nextPositionId) }}</strong> 
                              </div>

                            <!-- <div class="col-sm-6 text-center">
                              <button class="btn hvr-bounce-to-top form-control" title="Score Computation" (click)="getUserFunSkillInfo()">
                                Compute Score
                              </button>
                            </div> -->
                      </div>
                      <div class="col-md-8 addUserButton text-right">
                          <button type="button" class="btn hvr-bounce-to-top {{functionalActive}}" (click)="getUserFunSkillRatingInfo()">Functional Competencies
                          </button>
                          <button type="button" class="btn hvr-bounce-to-top mr10 {{behavioralActive}}" (click)="getUserBehSkillRatingInfo()">Behavioral Competencies
                          </button>
                          <a class="btn hvr-bounce-to-top mr10" href="assets/behCompetancy.pdf" target="_blank">Definition</a>
                         
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      
           
      
            <div class="addUserButtonTableData width100" *ngIf="selectedType === 'Fun' && isSkillDataPresent == true">
              <!-- <label class="skillLevel col-sm-12">Skill Development - Rating Scale: 1 (Low) To 5 (High) </label> -->
              <div class="addUserFormLayout customizeRtsScrollBar addUserFormContainer">
                <table datatable class="table rTsCustomizeTable">
                  <thead>
                    <tr>
                      <th style="width: 10%;">S.No.</th>
                      <th style="width: 60%;">Competencies To Develop</th>
                      <th style="width: 10%;">Target</th>
                      <th style="width: 10%;">Self</th>
                      <th style="width: 10%;">Manager</th>
                    </tr>
                  </thead>
                  <tbody class="text-center">
                    <ng-container *ngFor="let userSkill of userSkillRatingData; let i = index;">
                      <tr>
                        <td>
                          <div>{{userSkillRatingData.indexOf(userSkill) + 1}}</div>
                        </td>
                        <td class="userSelectType">
                          <div ngClass="{{userSkill.skillName}}">{{userSkill.skillName}}</div>
                        </td>
                       
                        <td class="userSelectType">
                          <div ngClass="{{userSkill.targetScore}}">{{userSkill.targetScore}}</div>
                        </td>
                        <td class="userSelectType">
                          <div ngClass="{{userSkill.selfRating}}">{{userSkill.selfRating}}</div>
                        </td>
                        <td class="userSelectType">
                          <div ngClass="{{userSkill.managerRating}}">{{userSkill.managerRating}}</div>
                        </td>
                       
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="addUserButtonTableData width100" *ngIf="selectedType === 'Beh' && isSkillDataPresent == true">
              <!-- <label class="skillLevel col-sm-12">Skill Development - Rating Scale: 1 (Low) To 5 (High) </label> -->
              <div class="addUserFormLayout customizeRtsScrollBar addUserFormContainer">
                <table datatable class="table rTsCustomizeTable">
                  <thead>
                    <tr>
                      <th style="width: 10%;">S.No.</th>
                      <th style="width: 60%;">Competencies To Develop</th>
                      <th style="width: 10%;">Target</th>
                      <th style="width: 10%;">Self</th>
                      <th style="width: 10%;">Manager</th>
                    </tr>
                  </thead>
                  <tbody class="text-center">
                    <ng-container *ngFor="let userSkill of userSkillRatingData; let i = index;">
                      <tr>
                        <td>
                          <div>{{userSkillRatingData.indexOf(userSkill) + 1}}</div>
                        </td>
                        <td class="userSelectType">
                          <div ngClass="{{userSkill.skillName}}">{{userSkill.skillName}}</div>
                        </td>
                      
                        <td class="userSelectType">
                          <div ngClass="{{userSkill.targetScore}}">{{userSkill.targetScore}}</div>
                        </td>
                        <td class="userSelectType">
                          <div ngClass="{{userSkill.selfRating}}">{{userSkill.selfRating}}</div>
                        </td>
                        <td class="userSelectType">
                          <div ngClass="{{userSkill.managerRating}}">{{userSkill.managerRating}}</div>
                        </td>
                        <!-- <td class="userSelectType">
                          <div ngClass="{{userSkill.compositeScrore}}">{{userSkill.compositeScrore}}</div>
                        </td> -->
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="stepSectionWrapper" *ngIf="userSkillRatingData.length === 0 || isSkillDataPresent == false">
              <div class="stepSection">
                <div class="starTop">
                  <i class="fa fa-star"></i>
                  <i class="fa fa-star"></i>
                  <i class="fa fa-star"></i>
                </div>
                <div class="step-1">
                  <p><strong class="highlight">Step 1</strong> First select the user from above drop down.</p>
                </div>
                <div class="step-2">
                  <p><strong class="highlight">Step 2</strong> Then select desired skill are from above right side options.</p>
                </div>
              </div>
            </div>

        </div>
      </div>
      
</div>


<div class="loader" *ngIf="loading">
    <div class="lds-roller">
        <!-- <img src="assets/preloader.gif" />
        <span>Wait...</span> -->
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</div>